/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EquipmentScheduleTypes } from './equipment-schedule-types';


export interface EquipmentScheduleJournalPointResponseDto { 
    dueAt?: string;
    scheduleId?: string | null;
    scheduleName?: string | null;
    scheduleType?: EquipmentScheduleTypes;
    modeId?: number | null;
    deviceCount?: number;
    sentCount?: number;
    failedCount?: number;
    skippedCount?: number;
    lastDispatchedAt?: string | null;
}



